import React from "react";

const Home = () => {
  return (
    <svg
      width="24px"
      height="21px"
      viewBox="0 0 24 21"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Group 6</title>
      <g
        id="Kanban-Dashboard-UI"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Tasks"
          transform="translate(-24.000000, -112.000000)"
          stroke="#6C6C6C"
        >
          <g id="menu2" transform="translate(0.000000, 113.000000)">
            <g id="Group-6" transform="translate(25.000000, 0.000000)">
              <polygon
                id="Stroke-1"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="18.173913 6.097135 18.173913 2.805 15.3043478 2.805 15.3043478 3.658655 11 0 0 9.35 1.91304348 9.35 1.91304348 18.7 8.60869565 18.7 8.60869565 13.09 13.3913043 13.09 13.3913043 18.7 20.0869565 18.7 20.0869565 9.35 22 9.35"
              ></polygon>
              <rect id="Rectangle" x="13.5" y="7.5" width="3" height="3"></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Home;
